import { render, staticRenderFns } from "./DetailsButton.vue?vue&type=template&id=8ca7cfca&scoped=true&"
import script from "./DetailsButton.vue?vue&type=script&lang=ts&"
export * from "./DetailsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca7cfca",
  null
  
)

export default component.exports